/**
 * **NB: Only capitalizes the letter at the beginning of the string
 *  and sentences. Does not do entire translations, e.g. from camelCase.**
 * @param {string} text
 */
export default function sentenceCase(text) {
    return text.replace(
        /(^|[.!?]+\s+)(\w)/g,
        (sub, prefix, letter) => `${prefix}${letter.toUpperCase()}`
    );
}